<template>
  <span class="chart-toolbox">
    <!-- <span class="unit-label">
      {{ Lang.label.unit }}：
    </span>
    <span class="unit">{{ props.unit }}</span>
    <div class="divider"></div> -->
    <span v-if="types.includes('groupBar')" :class="{active: chartType === 'groupBar'}">
      <i class="icon-a-tubiao1" @click="handleClickType('groupBar')"></i>
    </span>
    <span v-if="types.includes('line')" :class="{active: chartType === 'line'}">
      <i class="icon-a-tubiao1-1" @click="handleClickType('line')"></i>
    </span>
    <span v-if="types.includes('lineArea')" :class="{active: chartType === 'lineArea'}">
      <i class="icon-a-tubiao1-2" @click="handleClickType('lineArea')"></i>
    </span>
    <span v-if="types.includes('stackedBar')" :class="{active: chartType === 'stackedBar'}">
      <i class="icon-a-tubiao11"  @click="handleClickType('stackedBar')"></i>
    </span>
    <span v-if="types.includes('table')" :class="{active: chartType === 'table'}">
      <i class="icon-a-tubiao1-4"  @click="handleClickType('table')"></i>
    </span>
  </span>
</template>
<script setup>
  import { ref } from 'vue';
  import { Lang } from '@/lang/lang';
  const props = defineProps(['title', 'unit', 'types'])
  const emit = defineEmits(['click'])
  const chartType = ref('groupBar')
  function handleClickType(type) {
    chartType.value = type;
    emit('click', type)
  }
</script>
<style lang="scss" scoped>

</style>